import { useEffect } from 'react';

type PageMeta = {
  title: string;
  description: string;
  keywords: string;
  path: string;
  ogType?: string;
  image?: string;
};

const setMetaByName = (name: string, content: string) => {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('name', name);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setMetaByProperty = (property: string, content: string) => {
  let el = document.querySelector(`meta[property="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute('property', property);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setLink = (rel: string, href: string) => {
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

export default function usePageMeta({ title, description, keywords, path, ogType = 'website', image }: PageMeta) {
  useEffect(() => {
    const basePath = __BASE_PATH__.split('/').filter(Boolean).join('/');
    const prefix = basePath ? `/${basePath}` : '';
    const url = `${window.location.origin}${prefix}${path}`;

    document.title = title;
    setMetaByName('description', description);
    setMetaByName('keywords', keywords);
    setMetaByName('robots', 'index, follow');
    setMetaByName('author', '看料大瓜');

    setLink('canonical', url);

    setMetaByProperty('og:type', ogType);
    setMetaByProperty('og:site_name', '看料大瓜');
    setMetaByProperty('og:title', title);
    setMetaByProperty('og:description', description);
    setMetaByProperty('og:url', url);
    if (image) setMetaByProperty('og:image', image);

    setMetaByName('twitter:card', 'summary_large_image');
    setMetaByName('twitter:title', title);
    setMetaByName('twitter:description', description);
    if (image) setMetaByName('twitter:image', image);
  }, [title, description, keywords, path, ogType, image]);
}